import logo from '../images/logo.png'
export default function ApplicationLogo(props) {
    return (
        <img src={logo} className={'h-12'} alt={'Logo'} {...props}/>
    );
}
